import { StyledDataGrid } from "../../common/StyledComponents";
import { useDialog } from "../../context/DialogContext";
import ViewCampaignResult from "../../modal/ViewCampaignResult";
import ViewCampaignErrors from "../../modal/ViewCampaignErrors";
import { CustomToolbar } from "../campaigns/MassOutreach";
import DOMPurify from "dompurify";
import { useGridApiRef } from "@mui/x-data-grid-pro";
import React from "react";

export default function CampaignResultsDataGrid({
  rows,
  isLoading,
  idField = "campaignResultId",
  isErrorView = false,
  refetchRows,
}) {
  const dialog = useDialog();
  const apiRef = useGridApiRef();
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);

  const setSelectedResult = (result, displayedIndex) => {
    if (Number.isFinite(displayedIndex) && displayedIndex >= 0) {
      apiRef?.current.scrollToIndexes({
        rowIndex: displayedIndex,
        colIndex: 0,
      });
    }
    setRowSelectionModel([result[idField]]);
    if (isErrorView) {
      dialog.openModal("", ViewCampaignErrors, {
        campaignError: result,
        setSelectedResult,
      });
    } else {
      dialog.openModal("", ViewCampaignResult, {
        campaignResult: result,
        setSelectedResult,
        refetchRows,
      });
    }
  };

  const columns = [
    ...(isErrorView
      ? [
          {
            field: "errorMessage",
            headerName: "Error Message",
            flex: 200,
          },
        ]
      : []),
    { field: "salesPlatformProspectName", headerName: "Prospect", flex: 100 },
    { field: "salesPlatformProspectEmail", headerName: "Email", flex: 100 },
    { field: "companyName", headerName: "Company", flex: 100 },
    { field: "emailSubject", headerName: "Email subject", flex: 200 },
    {
      field: "personalizedMessage",
      headerName: "Personalized message",
      flex: 300,
      renderCell: (params) => (
        <div
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(params.value) }}
        />
      ),
    },
  ];

  return (
    <StyledDataGrid
      apiRef={apiRef}
      disableColumnMenu
      pagination
      initialState={{
        pagination: { paginationModel: { pageSize: 25 } },
      }}
      localeText={{ noRowsLabel: "No results found." }}
      loading={isLoading}
      pageSizeOptions={[10, 25, 50]}
      columns={columns}
      rows={rows || []}
      getRowId={(row) => row[idField]}
      sx={{
        height: "100%",
        mx: "30px",
        "& .MuiDataGrid-cellContent, & .MuiDataGrid-cell > div": {
          display: "-webkit-box",
          WebkitLineClamp: 4,
          WebkitBoxOrient: "vertical",
          whiteSpace: "pre-wrap",
          alignSelf: "center",
        },
      }}
      onRowClick={({ row }) => {
        setSelectedResult(row);
      }}
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      getRowHeight={() => "auto"}
      slots={{
        toolbar: CustomToolbar,
      }}
    />
  );
}
